import Debug from 'debug'
const debug = Debug('app:settings')

class settingsController {
  /* @ngInject */
  constructor (Users, Auth, $state, $rootScope, $mdDialog, company, user) {
    this.$rootScope = $rootScope
    this.Users = Users
    this.user = user
    this.Auth = Auth
    this.$state = $state
    this.company = company
    this.$mdDialog = $mdDialog
  }
  detail (settingsPage) {
    debug(this.company)
    this.$state.go('app.settings.' + settingsPage, {company: this.company})
  }
}
export default settingsController
